import { Grid, LeadBlock } from "@bmi-digital/components";
import Accordion from "@bmi-digital/components/accordion";
import { styled } from "@mui/material/styles";

export const StyledAccordionDetails = styled(Accordion.Details)(
  ({ theme }) => ({
    display: "block",
    padding: "0px",
    backgroundColor: theme.colours.white
  })
);

export const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "30px 0 0 0",
  [theme.breakpoints.up("xl")]: {
    padding: "0 0 0 24px"
  }
}));

export const StyledTechnicalSpecificationLeadBlock = styled(LeadBlock)({
  margin: 0,
  padding: "30px 0"
});

export const StyledLeadBlockContentSection = styled(LeadBlock.Content.Section)({
  marginBottom: 0
});
